export enum TimelineItemType {
  CURRENT = 'current',
  DEFAULT = 'default',
  EXPAND = 'expand',
  INIT = 'init'
}
